import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAcademiaComponent } from './simple-icons-academia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAcademiaComponent ],
    exports:      [ SimpleIconsAcademiaComponent ],
    bootstrap:    []
})
export class SimpleIconsAcademiaModule {}
